export default "__VITE_ASSET__f9187848__"